import styled from 'styled-components'

export const Header = styled.div`
  padding: 14rem 0 10rem;
  background-color: #f5f7ff;
`
